import { Form, Formik } from 'formik';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { Label } from 'reactstrap';
import * as Yup from 'yup';
import { IkioskMenuIds, IKioskMessage, IKIOSKModel, IKioskOtherServiceMenu, IkioskTokenType } from '../../../../models/kioskModel';
import { Ilanguages } from '../../../../models/utilitiesModel';
import { generateOtherServicesToken_Request, menuTypeAction, mobileNumberAction } from '../../../../store/actions';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

let prefix = "+971";
let exmple = "5xxxxxxxx";

const MobilenumberVarification: React.FC = () => {
    const { t } = useTranslation("translations");
    const dispatch = useDispatch();

    const formRef: any = useRef(null);
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const selectedPage: string = useSelector((state) => (state.kioskReducer as IKIOSKModel)?.selectedPage);
    const newPatientBranchdata: IKioskOtherServiceMenu = useSelector((state) => (state.kioskReducer as IKIOSKModel)?.isNewpatientRegistration || undefined);
    const layout = { default: ["1 2 3", "4 5 6", "7 8 9", "0 {bksp}"] };
    const errormessage: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.otherserviceErrorMessage || undefined);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    const messgageObj: any = kioskConfigMsgs?.find((x) => (x?.msgValueEn === errormessage) || (x?.msgValueAr === errormessage)) || undefined;
    const message: string = (language === Ilanguages.ENG) ? messgageObj?.msgValueEn : messgageObj?.msgValueAr;
    const display = { '{bksp}': (getLabelConfigMsg(kioskConfigMsgs, language,"delete") || t("kiosktranslation.delete" + language)), '{s}': '123' };
    console.log("newPatientBranchdata =>", errormessage);


    useEffect(() => {
        if (formRef?.current)
            formRef?.current?.setFieldValue('islanguageChanged', !(formRef?.current?.values?.islanguageChanged))
    }, [language])


    const keyboardRef: any = useRef();
    return (
        <div className="kiosk-content mrnstyle">
            <div className="content-sec w100 pad-btm15" >
                <div className="form-group frmInput">
                    {((newPatientBranchdata && selectedPage === IkioskMenuIds.NEWPATIENT) || selectedPage === IkioskMenuIds.INPUTMOBILE) &&
                        <Formik
                            enableReinitialize
                            initialValues={{
                                mobileNo: '',
                                keyboardopen: false,

                                islanguageChanged: false

                            }}
                            validationSchema={Yup.object().shape({
                                mobileNo: Yup.string()
                                    .matches(/^5/, t('controleErrors.startsWith5' + language))
                                    .required(t('controleErrors.required' + language)).max(9, t("controleErrors.maxLength" + language)).min(9, t("controleErrors.minLength" + language))
                            })}
                            innerRef={formRef}
                            onSubmit={(values) => {
                                let mobileNumber = `${prefix}${values?.mobileNo}`;
                                console.log("Onsubmit =>", mobileNumber, values);
                                if (selectedPage === IkioskMenuIds.INPUTMOBILE) {
                                    dispatch(mobileNumberAction(mobileNumber)); dispatch(menuTypeAction(IkioskMenuIds.DOBPAGE));
                                }
                                newPatientBranchdata && selectedPage === IkioskMenuIds.NEWPATIENT && dispatch(generateOtherServicesToken_Request(IkioskTokenType.NEWPATIENT, newPatientBranchdata?.branchId, mobileNumber));
                            }}>
                            {({ errors, touched, values, setFieldValue, setFieldTouched, dirty, isValid }) => (
                                <Form>
                                    <h1 className="welcome-heading">{(getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ARB, "welcometodubai") || t("kiosktranslation.welcometodubai-Ar"))}</h1>
                                    <h1 className="welcome-heading mt-2">{(getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ENG, "welcometodubai") || t("kiosktranslation.welcometodubai"))}</h1>
                                    {console.log("mobileVerificationFormik =>", values, errors, touched)}
                                    <div className='Kiosk_mobilenumber'>
                                        <div className="form-group k_formInput">
                                            <Label>{(getLabelConfigMsg(kioskConfigMsgs, language, "entermobile") || t("kiosktranslation.entermobile" + language))}</Label>
                                            <div className="input-group mb-2 d-flex">
                                                <span className="input-group-text" id="prefix-addon">{prefix}</span>
                                                <input
                                                    id="mobile-number"
                                                    autoComplete="off"
                                                    className='form-control flex-grow-1'
                                                    aria-describedby="prefix-addon"
                                                    onFocus={() => setFieldValue('keyboardopen', true)}
                                                    onBlur={() => setFieldTouched('mobileNo', true)}
                                                    value={values.mobileNo}
                                                    placeholder={(getLabelConfigMsg(kioskConfigMsgs, language, "entermobile") || t("kiosktranslation.entermobile" + language))}
                                                    // onChange={(event) => setFieldValue('mobileNo', event.target.value)}
                                                    onChange={(event) => console.log("input==>", event.target.value)}
                                                />
                                            </div>
                                            <div className='d-flex gap-3'>
                                                <span>{(getLabelConfigMsg(kioskConfigMsgs, language, "example") || t("kiosktranslation.example" + language))} {exmple}</span>
                                                {errors.mobileNo && touched.mobileNo && (
                                                    <span className='text-danger mobile-number-error'>{errors.mobileNo}</span>
                                                )}
                                            </div>
                                            <button type="submit" disabled={!dirty || !isValid} className='kiosk_generate_btn w-100 mt-4'>{(getLabelConfigMsg(kioskConfigMsgs, language, "Submit") || t("kiosktranslation.Submit" + language))}</button>
                                        </div>
                                        {values.keyboardopen && <div className='handle_btn' onClick={() => setFieldValue("keyboardopen", !values.keyboardopen)}></div>}
                                        {values.keyboardopen && (
                                            <>
                                                <Keyboard
                                                    // keyboardRef={(r) => (keyboardRef.current = r)}
                                                    keyboardRef={(r) => {
                                                        if (r && r?.input) {
                                                            r.input.default = values?.mobileNo;
                                                            keyboardRef.current = r;
                                                        }
                                                    }}
                                                    onChange={input => setFieldValue('mobileNo', input)}
                                                    layout={layout}
                                                    layoutName={"default"} // Dynamically adjust the layout
                                                    display={display}
                                                    buttonTheme={[
                                                        {
                                                            class: "default",
                                                            buttons:
                                                                "1 2 3 4 5 6 7 8 9 0",
                                                        },
                                                    ]}
                                                />
                                            </>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    }
                    {selectedPage === IkioskMenuIds.NEWPATIENT && errormessage && <span className="message_response">{errormessage === 'EM0' ? <p><span>{t('errorMessage.EM1' + language)}<br />{t('errorMessage.EM2' + language)}</span></p> : (message || errormessage)}</span>}
                </div>
            </div>
        </div>
    )
}
export default React.memo(MobilenumberVarification);
